/**
* VideResizer module
*
* for video background functionality
* checks asoect ratios of video element and it's container
* and depending on their values sets correct video size
* in order for video to take whole body space of a container
*/

class BackgroundVideo {
    /**
    * Constructor
    *
    * select all videos with .background-video selector
    * bind functions to proper context
    * call setup method
    */
    constructor() {

        this.videos = document.querySelectorAll( '.background-video' );
        // bindings
        this._setVideoSize = this._setVideoSize.bind( this );
        this._getVideoWidthAndHeight = this._getVideoWidthAndHeight.bind( this );
        this._getContainerWidthAndHeight = this._getContainerWidthAndHeight.bind( this );
        this._setupSizeDelayed = this._setupSizeDelayed.bind( this );
        // setup method
        this._setupVideoSizes();
    }

    /**
    * Call set videoSize method either immidiately or delayed depending on video readyState
    *
    * @since 1.0.0
    * @access private
    */
    _setupVideoSizes() {

         Object.keys( this.videos ).forEach( videoKey => {

             if ( this.videos[videoKey].readyState > 0 ) {

                 this._setVideoSize(
                     this.videos[videoKey],
                     this._getVideoWidthAndHeight( this.videos[videoKey] ),
                     this._getContainerWidthAndHeight( this.videos[videoKey] )
                 );
             } else {

                 this.videos[videoKey].addEventListener( 'loadedmetadata', this._setupSizeDelayed );
             }

         });

    }

    /**
    * call videoSize method (delay call when video metadata is not available)
    *
    * @since 1.0.0
    * @access private
    * @param {Object} e  DOM Event object
    */
    _setupSizeDelayed( e ) {
        this._setVideoSize(
            e.target,
            this._getVideoWidthAndHeight( e.target ),
            this._getContainerWidthAndHeight( e.target )
        );
    }

    /**
    * get video width and height
    *
    * @since 1.0.0
    * @access private
    * @param {DOMElement} videoElem video dom element
    * @return {Object}              object with width and height properties
    */
    _getVideoWidthAndHeight( videoElem ) {
        return {
            width: videoElem.videoWidth,
            height: videoElem.videoHeight
        };
    }

    /**
    * get video container width and height
    *
    * @since 1.0.0
    * @access private
    * @param {DOMElement} videoElem     video dom element
    * @return {Object}                  object with width and height properties
    */
    _getContainerWidthAndHeight( videoElem ) {

        const parent = videoElem.parentNode;

        return {
            width: parent.offsetWidth,
            height: parent.offsetHeight
        };
    }

    /**
    * set video size depending on ratio of video and video container element
    *
    * @since 1.0.0
    * @access private
    * @param {DOMElement} videoElem         video dom element
    * @param {Object}     videoSizes        object with video width and height
    * @param {Object}     containerSizes    object with video width and height
    */
    _setVideoSize( videoElem, videoSizes, containerSizes ) {
        const videoRatio = videoSizes.height / videoSizes.width;
        const containerRatio = containerSizes.height / containerSizes.width;

        // if video ratio is smaller than container fill container by width
        if ( videoRatio < containerRatio ) {
            videoElem.style.height = '100%';
            videoElem.style.width = 'auto';
        } else {
            videoElem.style.width = '100%';
            videoElem.style.height = 'auto';
        }
    }
}

export default BackgroundVideo;
